import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePatientRole } from '@/hooks/usePatientRole';
import { AppLayout } from '@/components/layout/AppLayout';
import { VitalRangesManager } from '@/components/patient/VitalRangesManager';
import { MedicalDisclaimerBanner } from '@/components/legal/MedicalDisclaimerBanner';

export default function VitalRangesList() {
  const { t } = useTranslation();
  const { patientId } = useParams();
  const navigate = useNavigate();
  const { canEdit: canEditRole, isPatientActive } = usePatientRole(patientId);
  const canEdit = canEditRole && isPatientActive;

  return (
    <AppLayout
      title={t('vitalRanges.title', { defaultValue: 'Limites Vitais' })}
      showBack
      onBack={() => navigate(`/app/patients/${patientId}`)}
    >
      <div className="p-4 pb-24 space-y-4">
        <MedicalDisclaimerBanner />
        {patientId && (
          <VitalRangesManager patientId={patientId} canEdit={canEdit} variant="list" />
        )}
      </div>
    </AppLayout>
  );
}
